module.exports = __webpack_public_path__ + "img/configuration.6584fd63.svg";